
export const getFormErrorValues = (errors) => {
  let result = ''
  Object.keys(errors).filter((field) => errors[field].length > 0).forEach((error) => {
    errors[error].forEach((errorLabel) => {
      result += '|' + error + ':' + errorLabel || 'error'
    })
  })

  return result.substring(1)
}
